import { useState } from "react";

const useGenericModal = (initialMode = false) => {
  const [modalOpen, setModalOpen] = useState(initialMode);
  const toggle = () => setModalOpen(!modalOpen);
  return { modalOpen, setModalOpen, toggle };
};

export default useGenericModal;
